<template>
  <footer class="bg-neutral text-neutral-content p-4">
    <div class="container mx-auto footer max-w-5xl">
      <div class="max-w-[12rem] mx-auto">
        <span class="footer-title"> Contact </span>
        <a href="mailto:contact@inscrib.io" class="link link-hover">
          contact@inscrib.io
        </a>
      </div>

      <div class="max-w-[12rem] mx-auto">
        <span class="footer-title"> Legal </span>
        <a class="link link-hover" href="/privacy"> Privacy policy </a>
        <a class="link link-hover" href="/cookies"> Cookies policy </a>
      </div>
    </div>
  </footer>
</template>
